var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 1.20218C10.6424 0.964221 9.83616 0.835938 9 0.835938C4.58172 0.835938 1 4.41766 1 8.83594C1 13.2542 4.58172 16.8359 9 16.8359C13.4183 16.8359 17 13.2542 17 8.83594C17 7.46368 16.6545 6.17211 16.0457 5.04349M13 3.83594H13.004M7.80004 16.7465L7.80013 14.9839C7.80013 14.8884 7.83429 14.7961 7.89642 14.7236L9.88505 12.4035C10.0485 12.2128 9.99784 11.9204 9.7798 11.7959L7.49483 10.4901C7.43274 10.4547 7.38131 10.4032 7.34587 10.3411L5.85637 7.73084C5.77885 7.59499 5.62926 7.51679 5.47347 7.53067L1.05135 7.92453M16.2 4.03594C16.2 5.80325 14.6 7.23594 13 8.83594C11.4 7.23594 9.8 5.80325 9.8 4.03594C9.8 2.26863 11.2327 0.835938 13 0.835938C14.7673 0.835938 16.2 2.26863 16.2 4.03594ZM13.2 3.83594C13.2 3.94639 13.1105 4.03594 13 4.03594C12.8895 4.03594 12.8 3.94639 12.8 3.83594C12.8 3.72548 12.8895 3.63594 13 3.63594C13.1105 3.63594 13.2 3.72548 13.2 3.83594Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.e8a23b3cca7aa7229483c2b0f4b5e0c7.svg";
export { ForwardRef as ReactComponent };